/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Bonisoft Backend API
 * Bonisoft Backend API
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ChangePasswordRequest,
  ErrorResponse,
  GetApiEmployeeCurrentShopmodulesTaxfreebenefitParams,
  GetApiTaxfreebenefitsParams,
  GetApiUsersCurrentNotificationsParams,
  GetApiWalletsWalletIdTransactionsParams,
  MeResponse,
  PermissionEntityType,
  PortalNotificationResponsePaginatedResponse,
  PortalNotificationStatus,
  SendFeedbackRequest,
  VoucherTypeModel,
  WalletTransactionResponsePaginatedResponse
} from '../../model';

import { axiosInstance } from '../../axios-instance';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getApiMe = (

 signal?: AbortSignal
) => {


      return axiosInstance<MeResponse>(
      {url: `/api/me`, method: 'GET', signal
    },
      );
    }




export const getGetApiMeQueryKey = () => {
    return [
    `/api/me`
    ] as const;
    }


export const getGetApiMeQueryOptions = <TData = Awaited<ReturnType<typeof getApiMe>>, TError = ErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiMe>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiMeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiMe>>> = ({ signal }) => getApiMe(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiMe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiMeQueryResult = NonNullable<Awaited<ReturnType<typeof getApiMe>>>
export type GetApiMeQueryError = ErrorResponse


export function useGetApiMe<TData = Awaited<ReturnType<typeof getApiMe>>, TError = ErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiMe>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiMe>>,
          TError,
          Awaited<ReturnType<typeof getApiMe>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiMe<TData = Awaited<ReturnType<typeof getApiMe>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiMe>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiMe>>,
          TError,
          Awaited<ReturnType<typeof getApiMe>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiMe<TData = Awaited<ReturnType<typeof getApiMe>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiMe>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiMe<TData = Awaited<ReturnType<typeof getApiMe>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiMe>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiMeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiLogout = (

 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/logout`, method: 'POST', signal
    },
      );
    }




export const getPostApiLogoutMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiLogout>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiLogout>>, TError,void, TContext> => {

const mutationKey = ['postApiLogout'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiLogout>>, void> = () => {


          return  postApiLogout()
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiLogoutMutationResult = NonNullable<Awaited<ReturnType<typeof postApiLogout>>>

    export type PostApiLogoutMutationError = ErrorResponse

    export const usePostApiLogout = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiLogout>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiLogout>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getPostApiLogoutMutationOptions(options), queryClient);
    }
    export const postApiFeedback = (
    sendFeedbackRequest?: SendFeedbackRequest,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/feedback`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendFeedbackRequest, signal
    },
      );
    }




export const getPostApiFeedbackMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiFeedback>>, TError,{data?: SendFeedbackRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiFeedback>>, TError,{data?: SendFeedbackRequest}, TContext> => {

const mutationKey = ['postApiFeedback'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiFeedback>>, {data?: SendFeedbackRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiFeedback(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiFeedbackMutationResult = NonNullable<Awaited<ReturnType<typeof postApiFeedback>>>
    export type PostApiFeedbackMutationBody = SendFeedbackRequest | undefined
    export type PostApiFeedbackMutationError = ErrorResponse

    export const usePostApiFeedback = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiFeedback>>, TError,{data?: SendFeedbackRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiFeedback>>,
        TError,
        {data?: SendFeedbackRequest},
        TContext
      > => {
      return useMutation(getPostApiFeedbackMutationOptions(options), queryClient);
    }
    export const getApiMeFeatures = (

 signal?: AbortSignal
) => {


      return axiosInstance<string[]>(
      {url: `/api/me/features`, method: 'GET', signal
    },
      );
    }




export const getGetApiMeFeaturesQueryKey = () => {
    return [
    `/api/me/features`
    ] as const;
    }


export const getGetApiMeFeaturesQueryOptions = <TData = Awaited<ReturnType<typeof getApiMeFeatures>>, TError = ErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiMeFeatures>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiMeFeaturesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiMeFeatures>>> = ({ signal }) => getApiMeFeatures(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiMeFeatures>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiMeFeaturesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiMeFeatures>>>
export type GetApiMeFeaturesQueryError = ErrorResponse


export function useGetApiMeFeatures<TData = Awaited<ReturnType<typeof getApiMeFeatures>>, TError = ErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiMeFeatures>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiMeFeatures>>,
          TError,
          Awaited<ReturnType<typeof getApiMeFeatures>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiMeFeatures<TData = Awaited<ReturnType<typeof getApiMeFeatures>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiMeFeatures>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiMeFeatures>>,
          TError,
          Awaited<ReturnType<typeof getApiMeFeatures>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiMeFeatures<TData = Awaited<ReturnType<typeof getApiMeFeatures>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiMeFeatures>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiMeFeatures<TData = Awaited<ReturnType<typeof getApiMeFeatures>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiMeFeatures>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiMeFeaturesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiWalletsWalletIdTransactions = (
    walletId: string,
    params?: GetApiWalletsWalletIdTransactionsParams,
 signal?: AbortSignal
) => {


      return axiosInstance<WalletTransactionResponsePaginatedResponse>(
      {url: `/api/wallets/${walletId}/transactions`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiWalletsWalletIdTransactionsQueryKey = (walletId: string,
    params?: GetApiWalletsWalletIdTransactionsParams,) => {
    return [
    `/api/wallets/${walletId}/transactions`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiWalletsWalletIdTransactionsQueryOptions = <TData = Awaited<ReturnType<typeof getApiWalletsWalletIdTransactions>>, TError = ErrorResponse>(walletId: string,
    params?: GetApiWalletsWalletIdTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWalletsWalletIdTransactions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiWalletsWalletIdTransactionsQueryKey(walletId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiWalletsWalletIdTransactions>>> = ({ signal }) => getApiWalletsWalletIdTransactions(walletId,params, signal);





   return  { queryKey, queryFn, enabled: walletId !== null && walletId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiWalletsWalletIdTransactions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiWalletsWalletIdTransactionsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiWalletsWalletIdTransactions>>>
export type GetApiWalletsWalletIdTransactionsQueryError = ErrorResponse


export function useGetApiWalletsWalletIdTransactions<TData = Awaited<ReturnType<typeof getApiWalletsWalletIdTransactions>>, TError = ErrorResponse>(
 walletId: string,
    params: undefined |  GetApiWalletsWalletIdTransactionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWalletsWalletIdTransactions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiWalletsWalletIdTransactions>>,
          TError,
          Awaited<ReturnType<typeof getApiWalletsWalletIdTransactions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiWalletsWalletIdTransactions<TData = Awaited<ReturnType<typeof getApiWalletsWalletIdTransactions>>, TError = ErrorResponse>(
 walletId: string,
    params?: GetApiWalletsWalletIdTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWalletsWalletIdTransactions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiWalletsWalletIdTransactions>>,
          TError,
          Awaited<ReturnType<typeof getApiWalletsWalletIdTransactions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiWalletsWalletIdTransactions<TData = Awaited<ReturnType<typeof getApiWalletsWalletIdTransactions>>, TError = ErrorResponse>(
 walletId: string,
    params?: GetApiWalletsWalletIdTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWalletsWalletIdTransactions>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiWalletsWalletIdTransactions<TData = Awaited<ReturnType<typeof getApiWalletsWalletIdTransactions>>, TError = ErrorResponse>(
 walletId: string,
    params?: GetApiWalletsWalletIdTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWalletsWalletIdTransactions>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiWalletsWalletIdTransactionsQueryOptions(walletId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiUsersUserIdPermissions = (
    userId: string,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/users/${userId}/permissions`, method: 'GET', signal
    },
      );
    }




export const getGetApiUsersUserIdPermissionsQueryKey = (userId: string,) => {
    return [
    `/api/users/${userId}/permissions`
    ] as const;
    }


export const getGetApiUsersUserIdPermissionsQueryOptions = <TData = Awaited<ReturnType<typeof getApiUsersUserIdPermissions>>, TError = ErrorResponse>(userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersUserIdPermissions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiUsersUserIdPermissionsQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUsersUserIdPermissions>>> = ({ signal }) => getApiUsersUserIdPermissions(userId, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiUsersUserIdPermissions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiUsersUserIdPermissionsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiUsersUserIdPermissions>>>
export type GetApiUsersUserIdPermissionsQueryError = ErrorResponse


export function useGetApiUsersUserIdPermissions<TData = Awaited<ReturnType<typeof getApiUsersUserIdPermissions>>, TError = ErrorResponse>(
 userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersUserIdPermissions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUsersUserIdPermissions>>,
          TError,
          Awaited<ReturnType<typeof getApiUsersUserIdPermissions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiUsersUserIdPermissions<TData = Awaited<ReturnType<typeof getApiUsersUserIdPermissions>>, TError = ErrorResponse>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersUserIdPermissions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUsersUserIdPermissions>>,
          TError,
          Awaited<ReturnType<typeof getApiUsersUserIdPermissions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiUsersUserIdPermissions<TData = Awaited<ReturnType<typeof getApiUsersUserIdPermissions>>, TError = ErrorResponse>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersUserIdPermissions>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiUsersUserIdPermissions<TData = Awaited<ReturnType<typeof getApiUsersUserIdPermissions>>, TError = ErrorResponse>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersUserIdPermissions>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiUsersUserIdPermissionsQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiUsersUserIdPermissionsEntityTypePermissionName = (
    userId: string,
    entityType: PermissionEntityType,
    permissionName: string,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/users/${userId}/permissions/${entityType}/${permissionName}`, method: 'POST', signal
    },
      );
    }




export const getPostApiUsersUserIdPermissionsEntityTypePermissionNameMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiUsersUserIdPermissionsEntityTypePermissionName>>, TError,{userId: string;entityType: PermissionEntityType;permissionName: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiUsersUserIdPermissionsEntityTypePermissionName>>, TError,{userId: string;entityType: PermissionEntityType;permissionName: string}, TContext> => {

const mutationKey = ['postApiUsersUserIdPermissionsEntityTypePermissionName'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiUsersUserIdPermissionsEntityTypePermissionName>>, {userId: string;entityType: PermissionEntityType;permissionName: string}> = (props) => {
          const {userId,entityType,permissionName} = props ?? {};

          return  postApiUsersUserIdPermissionsEntityTypePermissionName(userId,entityType,permissionName,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiUsersUserIdPermissionsEntityTypePermissionNameMutationResult = NonNullable<Awaited<ReturnType<typeof postApiUsersUserIdPermissionsEntityTypePermissionName>>>

    export type PostApiUsersUserIdPermissionsEntityTypePermissionNameMutationError = ErrorResponse

    export const usePostApiUsersUserIdPermissionsEntityTypePermissionName = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiUsersUserIdPermissionsEntityTypePermissionName>>, TError,{userId: string;entityType: PermissionEntityType;permissionName: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiUsersUserIdPermissionsEntityTypePermissionName>>,
        TError,
        {userId: string;entityType: PermissionEntityType;permissionName: string},
        TContext
      > => {
      return useMutation(getPostApiUsersUserIdPermissionsEntityTypePermissionNameMutationOptions(options), queryClient);
    }
    export const deleteApiUsersUserIdPermissionsEntityTypePermissionName = (
    userId: string,
    entityType: PermissionEntityType,
    permissionName: string,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/users/${userId}/permissions/${entityType}/${permissionName}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteApiUsersUserIdPermissionsEntityTypePermissionNameMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiUsersUserIdPermissionsEntityTypePermissionName>>, TError,{userId: string;entityType: PermissionEntityType;permissionName: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiUsersUserIdPermissionsEntityTypePermissionName>>, TError,{userId: string;entityType: PermissionEntityType;permissionName: string}, TContext> => {

const mutationKey = ['deleteApiUsersUserIdPermissionsEntityTypePermissionName'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiUsersUserIdPermissionsEntityTypePermissionName>>, {userId: string;entityType: PermissionEntityType;permissionName: string}> = (props) => {
          const {userId,entityType,permissionName} = props ?? {};

          return  deleteApiUsersUserIdPermissionsEntityTypePermissionName(userId,entityType,permissionName,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiUsersUserIdPermissionsEntityTypePermissionNameMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiUsersUserIdPermissionsEntityTypePermissionName>>>

    export type DeleteApiUsersUserIdPermissionsEntityTypePermissionNameMutationError = ErrorResponse

    export const useDeleteApiUsersUserIdPermissionsEntityTypePermissionName = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiUsersUserIdPermissionsEntityTypePermissionName>>, TError,{userId: string;entityType: PermissionEntityType;permissionName: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiUsersUserIdPermissionsEntityTypePermissionName>>,
        TError,
        {userId: string;entityType: PermissionEntityType;permissionName: string},
        TContext
      > => {
      return useMutation(getDeleteApiUsersUserIdPermissionsEntityTypePermissionNameMutationOptions(options), queryClient);
    }
    export const postApiUsersUserIdPermissionsEntityTypePermissionNameTargetEntityId = (
    userId: string,
    entityType: PermissionEntityType,
    permissionName: string,
    targetEntityId: number,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/users/${userId}/permissions/${entityType}/${permissionName}/${targetEntityId}`, method: 'POST', signal
    },
      );
    }




export const getPostApiUsersUserIdPermissionsEntityTypePermissionNameTargetEntityIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiUsersUserIdPermissionsEntityTypePermissionNameTargetEntityId>>, TError,{userId: string;entityType: PermissionEntityType;permissionName: string;targetEntityId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiUsersUserIdPermissionsEntityTypePermissionNameTargetEntityId>>, TError,{userId: string;entityType: PermissionEntityType;permissionName: string;targetEntityId: number}, TContext> => {

const mutationKey = ['postApiUsersUserIdPermissionsEntityTypePermissionNameTargetEntityId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiUsersUserIdPermissionsEntityTypePermissionNameTargetEntityId>>, {userId: string;entityType: PermissionEntityType;permissionName: string;targetEntityId: number}> = (props) => {
          const {userId,entityType,permissionName,targetEntityId} = props ?? {};

          return  postApiUsersUserIdPermissionsEntityTypePermissionNameTargetEntityId(userId,entityType,permissionName,targetEntityId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiUsersUserIdPermissionsEntityTypePermissionNameTargetEntityIdMutationResult = NonNullable<Awaited<ReturnType<typeof postApiUsersUserIdPermissionsEntityTypePermissionNameTargetEntityId>>>

    export type PostApiUsersUserIdPermissionsEntityTypePermissionNameTargetEntityIdMutationError = ErrorResponse

    export const usePostApiUsersUserIdPermissionsEntityTypePermissionNameTargetEntityId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiUsersUserIdPermissionsEntityTypePermissionNameTargetEntityId>>, TError,{userId: string;entityType: PermissionEntityType;permissionName: string;targetEntityId: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiUsersUserIdPermissionsEntityTypePermissionNameTargetEntityId>>,
        TError,
        {userId: string;entityType: PermissionEntityType;permissionName: string;targetEntityId: number},
        TContext
      > => {
      return useMutation(getPostApiUsersUserIdPermissionsEntityTypePermissionNameTargetEntityIdMutationOptions(options), queryClient);
    }
    export const deleteApiUsersUserIdPermissionsEntityTypePermissionNameTargetEntityId = (
    userId: string,
    entityType: PermissionEntityType,
    permissionName: string,
    targetEntityId: number,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/users/${userId}/permissions/${entityType}/${permissionName}/${targetEntityId}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteApiUsersUserIdPermissionsEntityTypePermissionNameTargetEntityIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiUsersUserIdPermissionsEntityTypePermissionNameTargetEntityId>>, TError,{userId: string;entityType: PermissionEntityType;permissionName: string;targetEntityId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiUsersUserIdPermissionsEntityTypePermissionNameTargetEntityId>>, TError,{userId: string;entityType: PermissionEntityType;permissionName: string;targetEntityId: number}, TContext> => {

const mutationKey = ['deleteApiUsersUserIdPermissionsEntityTypePermissionNameTargetEntityId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiUsersUserIdPermissionsEntityTypePermissionNameTargetEntityId>>, {userId: string;entityType: PermissionEntityType;permissionName: string;targetEntityId: number}> = (props) => {
          const {userId,entityType,permissionName,targetEntityId} = props ?? {};

          return  deleteApiUsersUserIdPermissionsEntityTypePermissionNameTargetEntityId(userId,entityType,permissionName,targetEntityId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiUsersUserIdPermissionsEntityTypePermissionNameTargetEntityIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiUsersUserIdPermissionsEntityTypePermissionNameTargetEntityId>>>

    export type DeleteApiUsersUserIdPermissionsEntityTypePermissionNameTargetEntityIdMutationError = ErrorResponse

    export const useDeleteApiUsersUserIdPermissionsEntityTypePermissionNameTargetEntityId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiUsersUserIdPermissionsEntityTypePermissionNameTargetEntityId>>, TError,{userId: string;entityType: PermissionEntityType;permissionName: string;targetEntityId: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiUsersUserIdPermissionsEntityTypePermissionNameTargetEntityId>>,
        TError,
        {userId: string;entityType: PermissionEntityType;permissionName: string;targetEntityId: number},
        TContext
      > => {
      return useMutation(getDeleteApiUsersUserIdPermissionsEntityTypePermissionNameTargetEntityIdMutationOptions(options), queryClient);
    }
    export const postApiUsersUserIdConfirmation = (
    userId: string,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/users/${userId}/confirmation`, method: 'POST', signal
    },
      );
    }




export const getPostApiUsersUserIdConfirmationMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiUsersUserIdConfirmation>>, TError,{userId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiUsersUserIdConfirmation>>, TError,{userId: string}, TContext> => {

const mutationKey = ['postApiUsersUserIdConfirmation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiUsersUserIdConfirmation>>, {userId: string}> = (props) => {
          const {userId} = props ?? {};

          return  postApiUsersUserIdConfirmation(userId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiUsersUserIdConfirmationMutationResult = NonNullable<Awaited<ReturnType<typeof postApiUsersUserIdConfirmation>>>

    export type PostApiUsersUserIdConfirmationMutationError = ErrorResponse

    export const usePostApiUsersUserIdConfirmation = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiUsersUserIdConfirmation>>, TError,{userId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiUsersUserIdConfirmation>>,
        TError,
        {userId: string},
        TContext
      > => {
      return useMutation(getPostApiUsersUserIdConfirmationMutationOptions(options), queryClient);
    }
    export const postApiUsersUserIdPassword = (
    userId: string,
    changePasswordRequest?: ChangePasswordRequest,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/users/${userId}/password`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: changePasswordRequest, signal
    },
      );
    }




export const getPostApiUsersUserIdPasswordMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiUsersUserIdPassword>>, TError,{userId: string;data?: ChangePasswordRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiUsersUserIdPassword>>, TError,{userId: string;data?: ChangePasswordRequest}, TContext> => {

const mutationKey = ['postApiUsersUserIdPassword'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiUsersUserIdPassword>>, {userId: string;data?: ChangePasswordRequest}> = (props) => {
          const {userId,data} = props ?? {};

          return  postApiUsersUserIdPassword(userId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiUsersUserIdPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof postApiUsersUserIdPassword>>>
    export type PostApiUsersUserIdPasswordMutationBody = ChangePasswordRequest | undefined
    export type PostApiUsersUserIdPasswordMutationError = ErrorResponse

    export const usePostApiUsersUserIdPassword = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiUsersUserIdPassword>>, TError,{userId: string;data?: ChangePasswordRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiUsersUserIdPassword>>,
        TError,
        {userId: string;data?: ChangePasswordRequest},
        TContext
      > => {
      return useMutation(getPostApiUsersUserIdPasswordMutationOptions(options), queryClient);
    }
    export const getApiTaxfreebenefits = (
    params?: GetApiTaxfreebenefitsParams,
 signal?: AbortSignal
) => {


      return axiosInstance<VoucherTypeModel[]>(
      {url: `/api/taxfreebenefits`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiTaxfreebenefitsQueryKey = (params?: GetApiTaxfreebenefitsParams,) => {
    return [
    `/api/taxfreebenefits`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiTaxfreebenefitsQueryOptions = <TData = Awaited<ReturnType<typeof getApiTaxfreebenefits>>, TError = string>(params?: GetApiTaxfreebenefitsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTaxfreebenefits>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiTaxfreebenefitsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiTaxfreebenefits>>> = ({ signal }) => getApiTaxfreebenefits(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiTaxfreebenefits>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiTaxfreebenefitsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiTaxfreebenefits>>>
export type GetApiTaxfreebenefitsQueryError = string


export function useGetApiTaxfreebenefits<TData = Awaited<ReturnType<typeof getApiTaxfreebenefits>>, TError = string>(
 params: undefined |  GetApiTaxfreebenefitsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTaxfreebenefits>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTaxfreebenefits>>,
          TError,
          Awaited<ReturnType<typeof getApiTaxfreebenefits>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiTaxfreebenefits<TData = Awaited<ReturnType<typeof getApiTaxfreebenefits>>, TError = string>(
 params?: GetApiTaxfreebenefitsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTaxfreebenefits>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTaxfreebenefits>>,
          TError,
          Awaited<ReturnType<typeof getApiTaxfreebenefits>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiTaxfreebenefits<TData = Awaited<ReturnType<typeof getApiTaxfreebenefits>>, TError = string>(
 params?: GetApiTaxfreebenefitsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTaxfreebenefits>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiTaxfreebenefits<TData = Awaited<ReturnType<typeof getApiTaxfreebenefits>>, TError = string>(
 params?: GetApiTaxfreebenefitsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTaxfreebenefits>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiTaxfreebenefitsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiEmployeeCurrentShopmodulesTaxfreebenefit = (
    params?: GetApiEmployeeCurrentShopmodulesTaxfreebenefitParams,
 signal?: AbortSignal
) => {


      return axiosInstance<VoucherTypeModel[]>(
      {url: `/api/employee/current/shopmodules/taxfreebenefit`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiEmployeeCurrentShopmodulesTaxfreebenefitQueryKey = (params?: GetApiEmployeeCurrentShopmodulesTaxfreebenefitParams,) => {
    return [
    `/api/employee/current/shopmodules/taxfreebenefit`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiEmployeeCurrentShopmodulesTaxfreebenefitQueryOptions = <TData = Awaited<ReturnType<typeof getApiEmployeeCurrentShopmodulesTaxfreebenefit>>, TError = string>(params?: GetApiEmployeeCurrentShopmodulesTaxfreebenefitParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiEmployeeCurrentShopmodulesTaxfreebenefit>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiEmployeeCurrentShopmodulesTaxfreebenefitQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiEmployeeCurrentShopmodulesTaxfreebenefit>>> = ({ signal }) => getApiEmployeeCurrentShopmodulesTaxfreebenefit(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiEmployeeCurrentShopmodulesTaxfreebenefit>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiEmployeeCurrentShopmodulesTaxfreebenefitQueryResult = NonNullable<Awaited<ReturnType<typeof getApiEmployeeCurrentShopmodulesTaxfreebenefit>>>
export type GetApiEmployeeCurrentShopmodulesTaxfreebenefitQueryError = string


export function useGetApiEmployeeCurrentShopmodulesTaxfreebenefit<TData = Awaited<ReturnType<typeof getApiEmployeeCurrentShopmodulesTaxfreebenefit>>, TError = string>(
 params: undefined |  GetApiEmployeeCurrentShopmodulesTaxfreebenefitParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiEmployeeCurrentShopmodulesTaxfreebenefit>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiEmployeeCurrentShopmodulesTaxfreebenefit>>,
          TError,
          Awaited<ReturnType<typeof getApiEmployeeCurrentShopmodulesTaxfreebenefit>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiEmployeeCurrentShopmodulesTaxfreebenefit<TData = Awaited<ReturnType<typeof getApiEmployeeCurrentShopmodulesTaxfreebenefit>>, TError = string>(
 params?: GetApiEmployeeCurrentShopmodulesTaxfreebenefitParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiEmployeeCurrentShopmodulesTaxfreebenefit>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiEmployeeCurrentShopmodulesTaxfreebenefit>>,
          TError,
          Awaited<ReturnType<typeof getApiEmployeeCurrentShopmodulesTaxfreebenefit>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiEmployeeCurrentShopmodulesTaxfreebenefit<TData = Awaited<ReturnType<typeof getApiEmployeeCurrentShopmodulesTaxfreebenefit>>, TError = string>(
 params?: GetApiEmployeeCurrentShopmodulesTaxfreebenefitParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiEmployeeCurrentShopmodulesTaxfreebenefit>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiEmployeeCurrentShopmodulesTaxfreebenefit<TData = Awaited<ReturnType<typeof getApiEmployeeCurrentShopmodulesTaxfreebenefit>>, TError = string>(
 params?: GetApiEmployeeCurrentShopmodulesTaxfreebenefitParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiEmployeeCurrentShopmodulesTaxfreebenefit>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiEmployeeCurrentShopmodulesTaxfreebenefitQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiUsersCurrentNotifications = (
    params?: GetApiUsersCurrentNotificationsParams,
 signal?: AbortSignal
) => {


      return axiosInstance<PortalNotificationResponsePaginatedResponse>(
      {url: `/api/users/current/notifications`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiUsersCurrentNotificationsQueryKey = (params?: GetApiUsersCurrentNotificationsParams,) => {
    return [
    `/api/users/current/notifications`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiUsersCurrentNotificationsQueryOptions = <TData = Awaited<ReturnType<typeof getApiUsersCurrentNotifications>>, TError = ErrorResponse>(params?: GetApiUsersCurrentNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersCurrentNotifications>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiUsersCurrentNotificationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUsersCurrentNotifications>>> = ({ signal }) => getApiUsersCurrentNotifications(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiUsersCurrentNotifications>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiUsersCurrentNotificationsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiUsersCurrentNotifications>>>
export type GetApiUsersCurrentNotificationsQueryError = ErrorResponse


export function useGetApiUsersCurrentNotifications<TData = Awaited<ReturnType<typeof getApiUsersCurrentNotifications>>, TError = ErrorResponse>(
 params: undefined |  GetApiUsersCurrentNotificationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersCurrentNotifications>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUsersCurrentNotifications>>,
          TError,
          Awaited<ReturnType<typeof getApiUsersCurrentNotifications>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiUsersCurrentNotifications<TData = Awaited<ReturnType<typeof getApiUsersCurrentNotifications>>, TError = ErrorResponse>(
 params?: GetApiUsersCurrentNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersCurrentNotifications>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUsersCurrentNotifications>>,
          TError,
          Awaited<ReturnType<typeof getApiUsersCurrentNotifications>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiUsersCurrentNotifications<TData = Awaited<ReturnType<typeof getApiUsersCurrentNotifications>>, TError = ErrorResponse>(
 params?: GetApiUsersCurrentNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersCurrentNotifications>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiUsersCurrentNotifications<TData = Awaited<ReturnType<typeof getApiUsersCurrentNotifications>>, TError = ErrorResponse>(
 params?: GetApiUsersCurrentNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersCurrentNotifications>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiUsersCurrentNotificationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiUsersCurrentNotificationsCount = (

 signal?: AbortSignal
) => {


      return axiosInstance<number>(
      {url: `/api/users/current/notifications/count`, method: 'GET', signal
    },
      );
    }




export const getGetApiUsersCurrentNotificationsCountQueryKey = () => {
    return [
    `/api/users/current/notifications/count`
    ] as const;
    }


export const getGetApiUsersCurrentNotificationsCountQueryOptions = <TData = Awaited<ReturnType<typeof getApiUsersCurrentNotificationsCount>>, TError = ErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersCurrentNotificationsCount>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiUsersCurrentNotificationsCountQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUsersCurrentNotificationsCount>>> = ({ signal }) => getApiUsersCurrentNotificationsCount(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiUsersCurrentNotificationsCount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiUsersCurrentNotificationsCountQueryResult = NonNullable<Awaited<ReturnType<typeof getApiUsersCurrentNotificationsCount>>>
export type GetApiUsersCurrentNotificationsCountQueryError = ErrorResponse


export function useGetApiUsersCurrentNotificationsCount<TData = Awaited<ReturnType<typeof getApiUsersCurrentNotificationsCount>>, TError = ErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersCurrentNotificationsCount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUsersCurrentNotificationsCount>>,
          TError,
          Awaited<ReturnType<typeof getApiUsersCurrentNotificationsCount>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiUsersCurrentNotificationsCount<TData = Awaited<ReturnType<typeof getApiUsersCurrentNotificationsCount>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersCurrentNotificationsCount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUsersCurrentNotificationsCount>>,
          TError,
          Awaited<ReturnType<typeof getApiUsersCurrentNotificationsCount>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiUsersCurrentNotificationsCount<TData = Awaited<ReturnType<typeof getApiUsersCurrentNotificationsCount>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersCurrentNotificationsCount>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiUsersCurrentNotificationsCount<TData = Awaited<ReturnType<typeof getApiUsersCurrentNotificationsCount>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersCurrentNotificationsCount>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiUsersCurrentNotificationsCountQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const patchApiUsersCurrentNotificationsNotificationIdStatus = (
    notificationId: number,
    portalNotificationStatus?: PortalNotificationStatus,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/users/current/notifications/${notificationId}/status`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: portalNotificationStatus, signal
    },
      );
    }




export const getPatchApiUsersCurrentNotificationsNotificationIdStatusMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiUsersCurrentNotificationsNotificationIdStatus>>, TError,{notificationId: number;data?: PortalNotificationStatus}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiUsersCurrentNotificationsNotificationIdStatus>>, TError,{notificationId: number;data?: PortalNotificationStatus}, TContext> => {

const mutationKey = ['patchApiUsersCurrentNotificationsNotificationIdStatus'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiUsersCurrentNotificationsNotificationIdStatus>>, {notificationId: number;data?: PortalNotificationStatus}> = (props) => {
          const {notificationId,data} = props ?? {};

          return  patchApiUsersCurrentNotificationsNotificationIdStatus(notificationId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiUsersCurrentNotificationsNotificationIdStatusMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiUsersCurrentNotificationsNotificationIdStatus>>>
    export type PatchApiUsersCurrentNotificationsNotificationIdStatusMutationBody = PortalNotificationStatus | undefined
    export type PatchApiUsersCurrentNotificationsNotificationIdStatusMutationError = ErrorResponse

    export const usePatchApiUsersCurrentNotificationsNotificationIdStatus = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiUsersCurrentNotificationsNotificationIdStatus>>, TError,{notificationId: number;data?: PortalNotificationStatus}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiUsersCurrentNotificationsNotificationIdStatus>>,
        TError,
        {notificationId: number;data?: PortalNotificationStatus},
        TContext
      > => {
      return useMutation(getPatchApiUsersCurrentNotificationsNotificationIdStatusMutationOptions(options), queryClient);
    }
